//image box animation
document.addEventListener("DOMContentLoaded", function () {
    const boxes = document.querySelectorAll(".box-block");

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add("visible");
          }, index * 200); // 200ms stagger
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    boxes.forEach(box => {
      observer.observe(box);
    });
  });

//typing text on travelling page

const elements = document.querySelectorAll('.typing-text');

elements.forEach((el) => {
  const fullHTML = el.innerHTML;
  el.innerHTML = ''; // Clear content
  let index = 0;
  let hasTyped = false;

  const typeText = () => {
    if (index >= fullHTML.length) return;

    let char = fullHTML.charAt(index);

    // Detect start of HTML tag
    if (char === '<') {
      let tag = '';
      while (char !== '>' && index < fullHTML.length) {
        tag += char;
        index++;
        char = fullHTML.charAt(index);
      }
      tag += '>'; // close the tag
      el.innerHTML += tag;
      index++; // move past '>'
    } else {
      el.innerHTML += char;
      index++;
    }

    setTimeout(typeText, 25);
  };

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && !hasTyped) {
        hasTyped = true;
        typeText();
      }
    },
    { threshold: 0.5 }
  );

  observer.observe(el);
});

//Slick slider

 jQuery(document).ready(function($){
	
        
        $(".hs-testimonial-boxes").slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            centerMode: false,
            autoplaySpeed: 1000,
            autoplay: true,


            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    }
                },
            ]
        });
	
});

/*Homepage Icon Boxex*/
jQuery(document).ready(function($) {
  function initImageBoxCarousel() {
    if ($(window).width() < 767) {
      if (!$('.icon-carousel').hasClass('slick-initialized')) {
        $('.icon-carousel').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          centerMode: false,
          autoplay: false,
          autoplaySpeed: 2000,
          responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });
      }
    } else {
      if ($('.icon-carousel').hasClass('slick-initialized')) {
        $('.icon-carousel').slick('unslick');
      }
    }
  }

  // Initialize on page load
  initImageBoxCarousel();

  // Re-initialize on window resize
  $(window).on('resize', function() {
    initImageBoxCarousel();
  });
});

/*Related Products*/
jQuery(document).ready(function($) {
  function initImageBoxCarousel() {
    if ($(window).width() < 767) {
      if (!$('.hs-related-products').hasClass('slick-initialized')) {
        $('.hs-related-products').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          centerMode: false,
          autoplay: false,
          autoplaySpeed: 2000,
          responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '40px',
                  infinite: true
                }
              }
            ]
        });
      }
    } else {
      if ($('.icon-carousel').hasClass('slick-initialized')) {
        $('.icon-carousel').slick('unslick');
      }
    }
  }

  // Initialize on page load
  initImageBoxCarousel();

  // Re-initialize on window resize
  $(window).on('resize', function() {
    initImageBoxCarousel();
  });
});

/*Hipsurfer Image Grid*/

jQuery(document).ready(function($) {
  function initImageBoxCarousel() {
    if ($(window).width() < 500) {
      if (!$('.hipsurfer-grid').hasClass('slick-initialized')) {
        $('.hipsurfer-grid').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          centerMode: false,
          autoplay: false,
          autoplaySpeed: 2000,
          responsive: [
              {
                breakpoint: 500,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });
      }
    } else {
      if ($('.icon-carousel').hasClass('slick-initialized')) {
        $('.icon-carousel').slick('unslick');
      }
    }
  }

  // Initialize on page load
  initImageBoxCarousel();

  // Re-initialize on window resize
  $(window).on('resize', function() {
    initImageBoxCarousel();
  });
});

/*Hipsurfer Icons Grid*/
jQuery(document).ready(function($) {
  function initImageBoxCarousel() {
    if ($(window).width() < 500) {
      if (!$('.hs-icon-grid').hasClass('slick-initialized')) {
        $('.hs-icon-grid').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          centerMode: false,
          autoplay: false,
          autoplaySpeed: 2000,
          responsive: [
              {
                breakpoint: 500,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });
      }
    } else {
      if ($('.icon-carousel').hasClass('slick-initialized')) {
        $('.icon-carousel').slick('unslick');
      }
    }
  }

  // Initialize on page load
  //initImageBoxCarousel();

  // Re-initialize on window resize
  $(window).on('resize', function() {
    //initImageBoxCarousel();
  });
});
